module.exports = __webpack_public_path__ + "img/testimoni-rifki-kecelakaandiri.c5ef744d.jpeg";